/**
 * @generated SignedSource<<92652770af15e1bc45154a9e1c7cf7bc>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type BranchSettingsDialog_pipeline$fragmentType = any;
type Graph_pipeline$fragmentType = any;
type Metrics_pipeline$fragmentType = any;
type Status_pipeline$fragmentType = any;
type Tag_tag$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type Pipeline_pipeline$fragmentType: FragmentType;
export type Pipeline_pipeline$data = {|
  +color: ?string,
  +defaultBranch: ?string,
  +description: ?string,
  +emoji: ?string,
  +favorite: boolean,
  +id: string,
  +name: string,
  +organization: {|
    +slug: string,
  |},
  +permissions: {|
    +pipelineFavorite: {|
      +allowed: boolean,
    |},
    +pipelineUpdate: {|
      +allowed: boolean,
    |},
  |},
  +public: boolean,
  +slug: string,
  +tags: $ReadOnlyArray<{|
    +label: string,
    +$fragmentSpreads: Tag_tag$fragmentType,
  |}>,
  +url: string,
  +uuid: string,
  +$fragmentSpreads: BranchSettingsDialog_pipeline$fragmentType & Graph_pipeline$fragmentType & Metrics_pipeline$fragmentType & Status_pipeline$fragmentType,
  +$fragmentType: Pipeline_pipeline$fragmentType,
|};
export type Pipeline_pipeline$key = {
  +$data?: Pipeline_pipeline$data,
  +$fragmentSpreads: Pipeline_pipeline$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "allowed",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "includeGraphData"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Pipeline_pipeline",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Status_pipeline"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Metrics_pipeline"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BranchSettingsDialog_pipeline"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "includeGraphData",
          "variableName": "includeGraphData"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Graph_pipeline"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "public",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultBranch",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "favorite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emoji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PipelineTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Tag_tag"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PipelinePermissions",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "pipelineFavorite",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "pipelineUpdate",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Pipeline",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "32671553f1aae407acb415a79e572ed1";

module.exports = ((node/*: any*/)/*: Fragment<
  Pipeline_pipeline$fragmentType,
  Pipeline_pipeline$data,
>*/);
